import { render } from "./BracketGrid.vue?vue&type=template&id=d67b22d6&scoped=true"
import script from "./BracketGrid.vue?vue&type=script&lang=js"
export * from "./BracketGrid.vue?vue&type=script&lang=js"

import "./BracketGrid.vue?vue&type=style&index=0&id=d67b22d6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d67b22d6"]])

export default __exports__